import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import fieldStatus from "helpers/fieldStatus"
import { Formik, Field, Form, FieldArray } from "formik"
import fields from "models/section"
import { Redirect } from "react-router-dom"
import * as Yup from "yup"
import ReactSelect from "components/ReactSelect"
import nullToEmptyString from "helpers/nullToEmptyString"
import _ from "lodash"
import Title from "../general/title"
import matchModel from "helpers/matchModel"
import { toast } from "react-toastify"
import TableRowField from "components/TableRowField"
import TextArea from "components/TextArea"
import NumberField from "components/NumberField"
import DateField from "components/DateField"
import settings from "settings"
import superagent from "superagent"
import moment from "moment"
import classnames from "classnames"
import reservesFields from "models/landFeature"

class EditSection extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ready: false,
			modal: false,
			fields,
			clone: _.cloneDeep(reservesFields),
			current_file: "",
			fence_file: "",
			fileName: "", // only for displaying by current_file
			fenceFileName: "",
		}
	}

	componentDidMount() {
		if (this.props.payloadStatus) {
			this.buildData()
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.payloadStatus !== this.props.payloadStatus) {
			this.buildData()
		}
	}

	buildData = () => {
		let id = parseInt(this.props.match.params.id)
		let section = _.find(this.props.payload.public.sections, { id: id })
		section = nullToEmptyString(section)
		let f = matchModel(fields, section)
		let current_file = f.plat_file ? f.plat_file : null
		f.plat_file = null
		let fileName
		if (current_file) {
			let split = current_file.split("/")
			fileName = _.last(split)
		}
		let fence_file = f.fence_plat_file ? f.fence_plat_file : null
		f.fence_plat_file = null
		let fenceFileName
		if (fence_file) {
			let split = fence_file.split("/")
			fenceFileName = _.last(split)
		}
		let reserves_list = []
		_.forEach(this.props.payload.public.land_features, (v) => {
			if (v.section_id !== id) return
			reserves_list.push(v)
		})
		f.reserves_list = reserves_list
		this.setState({ fields: f, current_file, fence_file, fileName, fenceFileName }, () => {
			//console.log(this.state.fields)
		})
	}

	validation = () => {
		return Yup.object().shape({
			name: Yup.string().required("Required"),
			legal_name: Yup.string().notRequired(),
			property: Yup.number().required("Required"),
			developers: Yup.array().notRequired(),
			//neighborhood: Yup.number().required("Required"),
			default_developer: Yup.number().notRequired(),
			subdivision: Yup.number().required("Required"),
			sqft_min: Yup.number().notRequired(),
			sqft_max: Yup.number().notRequired(),
			platted_lots: Yup.number().required("Required"),
			//isd: Yup.number().required("Required"),
			//acreage: Yup.number().required("Required"),
			substantially_complete: Yup.number().required("Required"),
			completion: Yup.number().required("Required"),
		})
	}

	buildNeighborhoods = () => {
		let ret = []
		_.forEach(this.props.payload.public.neighborhoods, (v) => {
			if (v.property == this.state.fields.property) {
				ret.push({ label: v.name, value: v.id })
			}
		})
		return ret
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	options = (f, name) => {
		let ret = []
		_.forEach(this.props.payload.public[name], (v) => {
			if (f.values.property && f.values.property == v.property) {
				ret.push({ label: v.name, value: v.id })
			}
		})

		ret = _.sortBy(ret, "label")
		return ret
	}

	optionsMulti = (f, name) => {
		let ret = []
		_.forEach(this.props.payload.public[name], (v) => {
			ret.push({ label: v.name, value: v.id })
		})

		ret = _.sortBy(ret, "label")
		return ret
	}

	optionsAlpha = (name) => {
		let opts = _.map(this.props.payload.public[name], (v) => {
			return { label: v.name, value: v.id }
		})
		opts = _.sortBy(opts, "label")
		return opts
	}

	renderReserveFields = (f, index, arrayHelpers) => {
		return (
			<React.Fragment>
				<li className={fieldStatus("name", f, true, index)}>
					<label htmlFor="name">
						Name <sup>*</sup>
					</label>
					{f.errors.length > 0 &&
						f.errors.reserves_list[index].name &&
						f.touched.reserves_list[index].name && (
							<div className="form__message">{f.errors.reserves_list[index].name}</div>
						)}
					<Field
						onBlur={() => f.setFieldTouched(`reserves_list[${index}].name`, true)}
						name={`reserves_list.${index}.name`}
						type="text"
						className="form__input"
					/>
				</li>
				<li className={fieldStatus("acreage", f, true, index)}>
					<label htmlFor="acreage">
						Acreage <sup>*</sup>
					</label>
					{f.errors.length > 0 &&
						f.errors.reserves_list[index].acreage &&
						f.touched.reserves_list[index].acreage && (
							<div className="form__message">{f.errors.reserves_list[index].acreage}</div>
						)}
					<NumberField
						name={`reserves_list.${index}.acreage`}
						type="text"
						className="form__input"
						onChange={(v, r) => f.setFieldValue(`reserves_list[${index}].acreage`, parseFloat(r))}
						onBlur={() => f.setFieldTouched(`reserves_list[${index}].acreage`, true)}
						touched={() => f.setFieldTouched(`reserves_list[${index}].acreage`, true)}
						//error={f.errors.reserves_list[index].acreage}
						value={f.values.reserves_list[index].acreage}
						thousandSeparator={true}
						float={true}
						decimals={5}
					/>
				</li>
				<li className={fieldStatus("type", f, true, index)}>
					<label htmlFor="type">
						Feature Type <sup>*</sup>
					</label>
					{f.errors.length > 0 &&
						f.errors.reserves_list[index].type &&
						f.touched.reserves_list[index].type && (
							<div className="form__message">{f.errors.reserves_list[index].type}</div>
						)}
					<ReactSelect
						name={`reserves_list.${index}.type`}
						keyVal={_.random(1, 999999)}
						options={this.optionsAlpha("land_feature_types")}
						value={f.values.reserves_list[index].type}
						onBlur={f.setFieldTouched}
						onChange={f.setFieldValue}
					/>
				</li>
				<li className={fieldStatus("owner", f, true, index)}>
					<label htmlFor="owner">Owner</label>
					{f.errors.length > 0 &&
						f.errors.reserves_list[index].owner &&
						f.touched.reserves_list[index].owner && (
							<div className="form__message">{f.errors.reserves_list[index].owner}</div>
						)}
					<Field
						onBlur={() => f.setFieldTouched(`reserves_list[${index}].owner`, true)}
						name={`reserves_list.${index}.owner`}
						type="text"
						className="form__input"
					/>
				</li>
				<li className={fieldStatus("transfer_date", f)}>
					<label htmlFor="transfer_date">Ownership Transfer Date</label>
					{f.errors.length > 0 &&
						f.errors.reserves_list[index].transfer_date &&
						f.touched.reserves_list[index].transfer_date && (
							<div className="form__message">{f.errors.reserves_list[index].transfer_date}</div>
						)}
					<DateField
						name={`reserves_list.${index}.transfer_date`}
						className="form__textarea"
						value={f.values.reserves_list[index].transfer_date}
						onChange={(v, r) => f.setFieldValue(`reserves_list[${index}].transfer_date`, r)}
						onBlur={f.setFieldTouched}
						//touched={f.touched.reserves_list[index].transfer_date}
						//error={f.errors.reserves_list[index].transfer_date}
					/>
				</li>
				<li className="form__subItemRemove">
					<i className="fa fa-minus-circle" onClick={() => arrayHelpers.remove(index)} />
				</li>
			</React.Fragment>
		)
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else if (this.state.redirect) {
			return <Redirect to={this.state.redirectPath} />
		} else {
			let curFile = this.state.fields.plat_file ? (
				<a href={`${settings.s3}${this.state.fields.plat_file}`} className="small">
					{" "}
					View File
				</a>
			) : (
				""
			)
			let fenceFile = this.state.fields.fence_plat_file ? (
				<a href={`${settings.s3}${this.state.fields.fence_plat_file}`} className="small">
					{" "}
					View File
				</a>
			) : (
				""
			)
			return (
				<div>
					<Title title="Edit Section" showDate={false} />
					<div className="content">
						<h3 />
						<Formik
							enableReinitialize
							validateOnMount={true}
							initialValues={this.state.fields}
							validationSchema={this.validation}
							onSubmit={(values) => {
								let json = JSON.stringify(values)
								this.props.loadingStatus(true)
								var fd = new FormData()
								for (let k in values) {
									fd.append(k, values[k])
								}
								var user = localStorage.getItem("user")
								let req = superagent
									.post(settings.ep + "/updateSection")
									.field("data", json)
									.set("Authorization", user)
								if (values.plat_file) {
									req.attach("plat_file", values.plat_file)
								}
								if (values.fence_plat_file) {
									req.attach("fence_plat_file", values.fence_plat_file)
								}
								req.end((err, resp) => {
									if (err) {
										console.log(err)
										toast.error("Error updating section.  Please notify developers.")
										return
									}
									this.props.loadingStatus(false)
									toast.success(resp.body.message)
									this.setState(
										{
											redirect: true,
											redirectPath: resp.body.redirect,
										},
										() => {
											this.props.getPayload()
										}
									)
								})
							}}>
							{(f) => (
								<div>
									{/* console.log(f) */}
									<Form>
										<ul className="form__list">
											<li className={fieldStatus("name", f)}>
												<label htmlFor="name">
													Name <sup>*</sup>
												</label>
												{f.errors.name && f.touched.name && (
													<div className="form__message">{f.errors.name}</div>
												)}
												<Field name="name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("legal_name", f)}>
												<label htmlFor="legal_name">Legal Name of Recorded Plat</label>
												{f.errors.legal_name && f.touched.legal_name && (
													<div className="form__message">{f.errors.legal_name}</div>
												)}
												<Field name="legal_name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("property", f)}>
												<label htmlFor="property">
													Property <sup>*</sup>
												</label>
												{f.errors.property && f.touched.property && (
													<div className="form__message">{f.errors.property}</div>
												)}
												<ReactSelect
													name={`property`}
													options={_.map(this.props.payload.public.properties, (v) => {
														return { label: v.name, value: v.id }
													})}
													value={f.values.property}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("tract", f)}>
												<label htmlFor="tract">Tract</label>
												{f.errors.tract && f.touched.tract && (
													<div className="form__message">{f.errors.tract}</div>
												)}
												<ReactSelect
													name={`tract`}
													options={this.options(f, "land_tracts")}
													value={f.values.tract}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("developers", f)}>
												<label htmlFor="developers">Developers</label>
												{f.errors.developers && f.touched.developers && (
													<div className="form__message">{f.errors.developers}</div>
												)}
												<ReactSelect
													name={`developers`}
													options={this.optionsMulti(f, "developers")}
													isMulti
													value={f.values.developers}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("neighborhood", f)}>
												<label htmlFor="neighborhood">Neighborhood</label>
												{f.errors.neighborhood && f.touched.neighborhood && (
													<div className="form__message">{f.errors.neighborhood}</div>
												)}
												<ReactSelect
													name={`neighborhood`}
													options={this.buildNeighborhoods()}
													value={f.values.neighborhood}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
													clearable
												/>
											</li>
											<li className={fieldStatus("default_developer", f)}>
												<label htmlFor="default_developer">Default Developer</label>
												{f.errors.default_developer && f.touched.default_developer && (
													<div className="form__message">{f.errors.default_developer}</div>
												)}
												<ReactSelect
													name={`default_developer`}
													options={this.optionsMulti(f, "developers")}
													value={f.values.default_developer}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("subdivision", f)}>
												<label htmlFor="subdivision">Subdivision</label>
												{f.errors.subdivision && f.touched.subdivision && (
													<div className="form__message">{f.errors.subdivision}</div>
												)}
												<ReactSelect
													name={`subdivision`}
													options={_.map(this.props.payload.public.subdivisions, (v) => {
														return { label: v.name, value: v.id }
													})}
													value={f.values.subdivision}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
													clearable
												/>
											</li>
											<li className={fieldStatus("description", f)}>
												<label htmlFor="description">Description</label>
												{f.errors.description && f.touched.description && (
													<div className="form__message">{f.errors.description}</div>
												)}
												<TextArea
													name="description"
													className="form__textarea"
													value={f.values.description}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.description}
													error={f.errors.description}
												/>
											</li>
											<li className={fieldStatus("isd", f)}>
												<label htmlFor="isd">ISD</label>
												{f.errors.isd && f.touched.isd && (
													<div className="form__message">{f.errors.isd}</div>
												)}
												<ReactSelect
													name={`isd`}
													options={_.map(this.props.payload.public.isds, (v) => {
														return { label: v.name, value: v.id }
													})}
													value={f.values.isd}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("high_school", f)}>
												<label htmlFor="high_school">High School</label>
												{f.errors.high_school && f.touched.high_school && (
													<div className="form__message">{f.errors.high_school}</div>
												)}
												<ReactSelect
													name={`high_school`}
													options={this.options(f, "schools")}
													value={f.values.high_school}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("middle_school", f)}>
												<label htmlFor="middle_school">Middle School</label>
												{f.errors.middle_school && f.touched.middle_school && (
													<div className="form__message">{f.errors.middle_school}</div>
												)}
												<ReactSelect
													name={`middle_school`}
													options={this.options(f, "schools")}
													value={f.values.middle_school}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											{settings?.enabled?.intermediateSchool && (
												<li className={fieldStatus("intermediate_school", f)}>
													<label htmlFor="intermediate_school">Intermediate School</label>
													{f.errors.intermediate_school && f.touched.intermediate_school && (
														<div className="form__message">
															{f.errors.intermediate_school}
														</div>
													)}
													<ReactSelect
														name={`intermediate_school`}
														options={this.options(f, "schools")}
														value={f.values.intermediate_school}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
											)}
											<li className={fieldStatus("elementary_school", f)}>
												<label htmlFor="elementary_school">Elementary School</label>
												{f.errors.elementary_school && f.touched.elementary_school && (
													<div className="form__message">{f.errors.elementary_school}</div>
												)}
												<ReactSelect
													name={`elementary_school`}
													options={this.options(f, "schools")}
													value={f.values.elementary_school}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("lid", f)}>
												<label htmlFor="lid">LID</label>
												{f.errors.lid && f.touched.lid && (
													<div className="form__message">{f.errors.lid}</div>
												)}
												<ReactSelect
													name={`lid`}
													options={_.map(this.props.payload.public.lids, (v) => {
														return { label: v.name, value: v.id }
													})}
													value={f.values.lid}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("acreage", f)}>
												<label htmlFor="acreage">Acreage</label>
												{f.errors.acreage && f.touched.acreage && (
													<div className="form__message">{f.errors.acreage}</div>
												)}
												<Field name="acreage" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("sqft_min", f)}>
												<label htmlFor="sqft_min">Square Feet Min</label>
												{f.errors.sqft_min && f.touched.sqft_min && (
													<div className="form__message">{f.errors.sqft_min}</div>
												)}
												<NumberField
													name="sqft_min"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.sqft_min}
													error={f.errors.sqft_min}
													value={f.values.sqft_min}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("sqft_max", f)}>
												<label htmlFor="sqft_max">Square Feet Max</label>
												{f.errors.sqft_max && f.touched.sqft_max && (
													<div className="form__message">{f.errors.sqft_max}</div>
												)}
												<NumberField
													name="sqft_max"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.sqft_max}
													error={f.errors.sqft_max}
													value={f.values.sqft_max}
													thousandSeparator={true}
												/>
											</li>
											{/* <li className={fieldStatus("mud", f)}>
												<label htmlFor="mud">MUD</label>
												{f.errors.mud && f.touched.mud && (
													<div className="form__message">{f.errors.mud}</div>
												)}
												<ReactSelect
													name={`mud`}
													options={_.map(this.props.payload.public.muds, (v) => {
														return { label: v.name, value: v.id }
													})}
													value={f.values.mud}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li> */}
											<li className={fieldStatus("completion", f)}>
												<label htmlFor="completion">
													Substantial Completion Date<sup>*</sup>
												</label>
												{f.errors.completion && f.touched.completion && (
													<div className="form__message">{f.errors.completion}</div>
												)}
												<div className="form__infoMessage">Or estimated date</div>
												<DateField
													name="completion"
													className="form__textarea"
													value={f.values.completion}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.completion}
													error={f.errors.completion}
												/>
											</li>
											<li className={fieldStatus("substantially_complete", f)}>
												<label htmlFor="substantially_complete">
													Substantially Complete<sup>*</sup>
												</label>
												{f.errors.substantially_complete &&
													f.touched.substantially_complete && (
														<div className="form__message">
															{f.errors.substantially_complete}
														</div>
													)}
												<ReactSelect
													name={`substantially_complete`}
													options={[
														{ label: "No", value: 0 },
														{ label: "Yes", value: 1 },
													]}
													value={f.values.substantially_complete}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("platted_lots", f)}>
												<label htmlFor="platted_lots">
													Platted Lots<sup>*</sup>
												</label>
												{f.errors.platted_lots && f.touched.platted_lots && (
													<div className="form__message">{f.errors.platted_lots}</div>
												)}
												<NumberField
													name="platted_lots"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.platted_lots}
													error={f.errors.platted_lots}
													value={f.values.platted_lots}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("default_lot_type_id", f)}>
												<label htmlFor="default_lot_type_id">Default Lot Type</label>
												{f.errors.default_lot_type_id && f.touched.default_lot_type_id && (
													<div className="form__message">{f.errors.default_lot_type_id}</div>
												)}
												<ReactSelect
													name={`default_lot_type_id`}
													options={this.options(f, "lot_types")}
													value={f.values.default_lot_type_id}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
													clearable={true}
												/>
											</li>
											<li className={fieldStatus("plat_num", f)}>
												<label htmlFor="plat_num">Plat Number</label>
												{f.errors.plat_num && f.touched.plat_num && (
													<div className="form__message">{f.errors.plat_num}</div>
												)}
												<Field name="plat_num" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("plat_record_date", f)}>
												<label htmlFor="plat_record_date">Plat Record Date</label>
												{f.errors.plat_record_date && f.touched.plat_record_date && (
													<div className="form__message">{f.errors.plat_record_date}</div>
												)}
												<DateField
													name="plat_record_date"
													className="form__textarea"
													value={f.values.plat_record_date}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.plat_record_date}
													error={f.errors.plat_record_date}
												/>
											</li>
											<li className={fieldStatus("plat_file", f)}>
												<label htmlFor="plat_file">Plat File {curFile}</label>
												{f.errors.plat_file && f.touched.plat_file && (
													<div className="form__message">{f.errors.plat_file}</div>
												)}
												{this.state.current_file && (
													<a
														href={`${settings.s3}${
															this.state.current_file
														}?v=${moment().unix()}`}
														target="_blank"
														key={this.state.current_file}
														className="small"
														style={{ marginBottom: 20 }}>
														Current File: {this.state.fileName}
													</a>
												)}
												<input
													name="plat_file"
													type="file"
													id="plat_file"
													className={classnames("noBorder", {
														fileHideText: this.state.current_file,
													})}
													//className="noBorder fileHideText"
													onChange={(event) => {
														f.setFieldValue("plat_file", event.currentTarget.files[0])
													}}
												/>
											</li>
											<li className={fieldStatus("fence_plat_file", f)}>
												<label htmlFor="fence_plat_file">Fence Plat File {fenceFile}</label>
												{f.errors.fence_plat_file && f.touched.fence_plat_file && (
													<div className="form__message">{f.errors.fence_plat_file}</div>
												)}
												{this.state.fence_file && (
													<a
														href={`${settings.s3}${
															this.state.fence_file
														}?v=${moment().unix()}`}
														target="_blank"
														key={this.state.fence_file}
														className="small"
														style={{ marginBottom: 20 }}>
														Current File: {this.state.fenceFileName}
													</a>
												)}
												<input
													name="fence_plat_file"
													type="file"
													id="fence_plat_file"
													className={classnames("noBorder", {
														fileHideText: this.state.fence_file,
													})}
													//className="noBorder fileHideText"
													onChange={(event) => {
														f.setFieldValue("fence_plat_file", event.currentTarget.files[0])
													}}
												/>
											</li>
											<li className={fieldStatus("reserves", f)}>
												<label htmlFor="reserves">Number of Reserves</label>
												{f.errors.reserves && f.touched.reserves && (
													<div className="form__message">{f.errors.reserves}</div>
												)}
												<Field name="reserves" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("senior", f)}>
												<label htmlFor="senior">Active Adult?</label>
												{f.errors.senior && f.touched.senior && (
													<div className="form__message">{f.errors.senior}</div>
												)}
												<ReactSelect
													name={`senior`}
													options={[
														{ label: "No", value: 0 },
														{ label: "Yes", value: 1 },
													]}
													value={f.values.senior}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("gated", f)}>
												<label htmlFor="gated">Gated Section?</label>
												{f.errors.gated && f.touched.gated && (
													<div className="form__message">{f.errors.gated}</div>
												)}
												<ReactSelect
													name={`gated`}
													options={[
														{ label: "No", value: 0 },
														{ label: "Yes", value: 1 },
													]}
													value={f.values.gated}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("model_park", f)}>
												<label htmlFor="model_park">Model Park</label>
												{f.errors.model_park && f.touched.model_park && (
													<div className="form__message">{f.errors.model_park}</div>
												)}
												<ReactSelect
													name={`model_park`}
													options={[
														{ label: "No", value: 0 },
														{ label: "Yes", value: 1 },
													]}
													value={f.values.model_park}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("btr", f)}>
												<label htmlFor="btr">Build to Rent</label>
												{f.errors.btr && f.touched.btr && (
													<div className="form__message">{f.errors.btr}</div>
												)}
												<ReactSelect
													name={`btr`}
													options={[
														{ label: "No", value: 0 },
														{ label: "Yes", value: 1 },
													]}
													value={f.values.btr}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											{settings?.enabled?.directToProspect ? (
												<li className={fieldStatus("direct_to_prospect", f)}>
													<label htmlFor="direct_to_prospect">
														Lots Sell Direct To Prospect?
													</label>
													{f.errors.direct_to_prospect && f.touched.direct_to_prospect && (
														<div className="form__message">
															{f.errors.direct_to_prospect}
														</div>
													)}
													<ReactSelect
														name={`direct_to_prospect`}
														options={[
															{ label: "No", value: 0 },
															{ label: "Yes", value: 1 },
														]}
														value={f.values.direct_to_prospect}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
											) : null}
											<li className={fieldStatus("estimated_delivery", f)}>
												<label htmlFor="estimated_delivery">Estimated Lot Delivery</label>
												{f.errors.estimated_delivery && f.touched.estimated_delivery && (
													<div className="form__message">{f.errors.estimated_delivery}</div>
												)}
												<DateField
													name="estimated_delivery"
													className="form__textarea"
													value={f.values.estimated_delivery}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.estimated_delivery}
													error={f.errors.estimated_delivery}
												/>
											</li>
										</ul>
										<h3>Lot Types</h3>
										<TableRowField
											delete={true}
											fields={[
												{
													type: "select",
													name: "lot_type",
													lookup: "lot_types",
													header: "Lot Type",
													clearable: true,
													//placeholder: "All Lots",
													dependent: "property",
													dependentVal: this.props.activeProperties?.[0],
												},
												{
													type: "number",
													name: "amount",
													float: true,
													decimals: 2,
													header: "Tax Value Per Lot",
												},
												{
													type: "number",
													name: "appraised",
													float: true,
													decimals: 2,
													header: "Appraised Value",
												},
											]}
											data={f.values.lot_types_tax_values}
											onChange={(v) => f.setFieldValue("lot_types_tax_values", v)}
										/>
										<h3 className="mt-4">Reserves</h3>
										<FieldArray
											name="reserves_list"
											render={(arrayHelpers) => (
												<div>
													<p className="traffic__addMore">
														<span
															onClick={() => {
																let c = _.cloneDeep(this.state.clone)
																console.log(c)
																return arrayHelpers.insert(0, c)
															}}>
															<i className="fa fa-plus-circle" />
															Add Another Reserve
														</span>
													</p>
													<ul>
														{f.values.reserves_list && f.values.reserves_list.length > 0
															? f.values.reserves_list.map((row, index) => (
																	<li key={index}>
																		<ul className="form__subList">
																			{this.renderReserveFields(
																				f,
																				index,
																				arrayHelpers
																			)}
																		</ul>
																	</li>
															  ))
															: ""}
													</ul>
												</div>
											)}
										/>
										<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
									</Form>
								</div>
							)}
						</Formik>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(EditSection)
